'use client';

import GoogleOneTap from '@alltrails/layout/components/GoogleOneTap';
import useScrollAuthHoldoutExposureOnMount from '@alltrails/layout/hooks/useAuthScrollHoldoutExposureOnMount';
import useBraze from '@alltrails/layout/hooks/useBraze';
import useOsano from '@alltrails/layout/hooks/useOsano';
import useTinuitiPixel from '@alltrails/layout/hooks/useTinuitiPixel';
import AmplitudeBrowserSdk from '@alltrails/layout/scripts/AmplitudeBrowserSdk';
import { DatadogRumScript } from '@alltrails/stability';
import ReturningUserUpsell from '@alltrails/upsell/components/ReturningUserUpsell/ReturningUserUpsell';
import useAppleRedirectHandler from '@alltrails/user-auth/hooks/useAppleRedirectHandler';

const LocationPageAnalytics = () => {
  useOsano();
  useTinuitiPixel();
  useBraze();
  useAppleRedirectHandler();
  useScrollAuthHoldoutExposureOnMount();

  return (
    <>
      <DatadogRumScript sessionSampleRate={5} />
      <AmplitudeBrowserSdk />
      <GoogleOneTap pageViewLimitReached={false} />
      <ReturningUserUpsell />
    </>
  );
};

export default LocationPageAnalytics;
